module.exports = {  
  YOUTUBE_API_KEY:process.env.REACT_APP_YOUTUBE_API_KEY || "AIzaSyDlRgqe-5O5YUjPJ6Q3700mAGwrxBZGOyY"
  };
  